<template>
  <div class="pop">
    <div class="popover-tag" @click.stop="pop($event)">
      <slot ref="slot" />
    </div>
    <div class="popover-wrap" :style="{ visibility: show ? 'visible' : 'hidden' }" ref="pop" :class="[typeCodes === 2 ? 'popover-codes' : '']">
      <div class="popover-box">
        <div class="popover-effe" v-for="(item, i) in barList" :key="i">
          <div class="popover-effecont">
            <!-- 规则是2/3/4时 -->
            <div v-if="ruleLevel < 5" class="popover-effetit">
              <span v-if="i === 0" class="popover-effenum">有效使用天数</span>
              <span v-if="i === 0" class="popover-effeday">(销售{{ transLeavel(ruleLevel) }}单/天)</span>
              <span v-if="i === 1 && ruleLevel === 2" class="popover-effenum">销售流水总额</span>
              <span v-if="i === 1 && ruleLevel === 3" class="popover-effenum">日均流水金额</span>
              <span v-if="i === 1 && ruleLevel === 4" class="popover-effenum">销售流水总额</span>
              <span v-if="i === 2" class="popover-effenum">采购入库单量</span>
            </div>
            <!-- 规则是5以上时 -->
            <div v-if="ruleLevel >= 5" class="popover-effetit">
              <span class="popover-effenum">{{ item.kpiItemName }}</span>
            </div>
            <div class="popover-effepro">
              <div class="popover-effespeed">
                <van-progress :percentage="barPro(item.current, item.total)" :show-pivot="false" />
              </div>
              <div class="popover-effeproday">{{ setNumMillion(item.current) }}/{{ setNumMillion(item.total) }}</div>
            </div>
          </div>
        </div>

        <div class="popover-arrow popover-arrow-top" :class="[typeCodes === 2 ? 'popover-arrowcodes' : '']" />
      </div>
    </div>
  </div>
</template>
<script>
import { deeppink } from "color-name"
export default {
  props: {
    ruleLevel: {
      type: Number,
      default: 5
    },
    barList: {
      type: Array,
      default: () => []
    },
    typeCode: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
      arrowLeft: 0,
      x: 0,
      y: 0,
      typeCodes: 0
    }
  },
  computed: {
    barPro() {
      let ratio = 0
      return function(current, total) {
        if (current > total) {
          ratio = 100
        } else {
          ratio = (current * 100) / total
        }
        return ratio
      }
    },
    transLeavel() {
      let leavel
      return function(ruleLevel) {
        if (ruleLevel === 2) {
          leavel = 5
        } else if (ruleLevel === 3) {
          leavel = 1
        } else if (ruleLevel === 4) {
          leavel = 10
        }
        return leavel
      }
    }
  },
  watch: {
    typeCode: {
      handler(newValue, oldValue) {
        this.typeCodes = newValue
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    document.body.addEventListener("touchstart", this.closeShow, true)
  },
  destroyed() {
    document.body.removeEventListener("touchstart", this.closeShow, true)
  },
  methods: {
    // 数字超过万 以万为单位 保留1位小数
    setNumMillion(num) {
      if (num >= 10000) {
        const numNew = num / 10000
        return numNew.toFixed(1) + "w"
      } else {
        return num
      }
    },
    pop(e) {
      if (this.show) {
        this.show = false
        return
      }
      this.show = true
    },
    closeShow(e) {
      if (this.$slots && this.$slots.default) {
        if (e.target.offsetParent.offsetParent !== this.$slots.default[0].elm) {
          this.show = false
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.pop {
  position: relative;
  .popover-wrap {
    position: relative;
    z-index: 9999;
    left: -10px;
    top: 7px;
    .popover-box {
      border-radius: 2%;
      background: #ffffff;
      width: 230px;
      // height: 190px;
      padding-bottom: 25px;
      position: absolute;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.09);
      .popover-effe {
        font-size: 12px;
        margin-left: 20px;
        margin-top: 10px;
        font-weight: 400;
        color: #343d54;
        .popover-effecont {
          .popover-effetit {
            padding: 3px 0;
            margin-bottom: 8px;
            display: block;
            .popover-effenum {
              font-family: PingFangSC-Regular, PingFang SC;
              margin-right: 3px;
            }
          }
          .popover-effepro {
            display: flex;
            align-items: center;
            .popover-effespeed {
              width: 115px;
              height: 8px;
              margin-right: 8px;
              .van-progress {
                width: 115px;
                height: 8px;
                border: 1px solid rgba(245, 245, 245, 1);
                background: none;
                /deep/ .van-progress__portion {
                  background: linear-gradient(to right, #ff9356, #ff5833) !important;
                }
              }
            }
            .popover-effeproday {
              font-family: "mount";
              color: #f8a15b;
            }
          }
        }
      }
      .popover-arrow {
        left: 30px;
        position: absolute;
        border: 7px solid transparent;
        border-top-width: 0;
        border-bottom-color: #ffffff;
        top: -5px;
      }
      .popover-arrowcodes {
        left: 165px;
      }
    }
  }
  .popover-codes {
    left: -133px;
    top: -2px;
  }
}
</style>
